(function () {
  "use strict";

  var MAPLIBRE_JS = "https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.js";
  var MAPLIBRE_CSS = "https://unpkg.com/maplibre-gl@4.7.1/dist/maplibre-gl.css";
  var DEFAULT_STYLE = "https://tiles.openfreemap.org/styles/liberty";

  var MAPBOX_JS = "https://api.mapbox.com/mapbox-gl-js/v3.7.0/mapbox-gl.js";
  var MAPBOX_CSS = "https://api.mapbox.com/mapbox-gl-js/v3.7.0/mapbox-gl.css";
  var MAPBOX_STYLE = "mapbox://styles/mapbox/streets-v12";
  var BRAND_COLOR = "#cc0000";

  function loadLib(o) {
    return new Promise(function (resolve, reject) {
      if (window[o.global]) return resolve(window[o.global]);
      if (!document.querySelector("link[" + o.cssAttr + "]")) {
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = o.css;
        link.setAttribute(o.cssAttr, "1");
        document.head.appendChild(link);
      }
      var existing = document.querySelector("script[" + o.jsAttr + "]");
      if (existing) {
        existing.addEventListener("load", function () { resolve(window[o.global]); });
        existing.addEventListener("error", reject);
        return;
      }
      var s = document.createElement("script");
      s.src = o.js;
      s.setAttribute(o.jsAttr, "1");
      s.onload = function () { resolve(window[o.global]); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  function ensureMapLibre() {
    return loadLib({ global: "maplibregl", js: MAPLIBRE_JS, css: MAPLIBRE_CSS, cssAttr: "data-sl-mlcss", jsAttr: "data-sl-mljs" });
  }
  function ensureMapbox() {
    return loadLib({ global: "mapboxgl", js: MAPBOX_JS, css: MAPBOX_CSS, cssAttr: "data-sl-mbcss", jsAttr: "data-sl-mbjs" });
  }

  function loadMapImage(map, url) {
    return new Promise(function (resolve, reject) {
      var ret = map.loadImage(url, function (err, image) {
        if (err) reject(err); else resolve(image);
      });
      if (ret && typeof ret.then === "function") {
        ret.then(function (r) { resolve(r && r.data ? r.data : r); }, reject);
      }
    });
  }

  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }

  function escapeHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function distanceKm(lng1, lat1, lng2, lat2) {
    var R = 6371, toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad, dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  function fmtDistance(km) {
    var mi = km * 0.621371;
    return mi < 10 ? mi.toFixed(1) + " mi" : Math.round(mi) + " mi";
  }

  var SVG_PIN =
    '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="#9aa0a6" stroke-width="1.6">' +
    '<path d="M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11z"/><circle cx="12" cy="10" r="2.4"/></svg>';

  function initWidget(maplibregl, root, forceFree) {
    var storesUrl = root.getAttribute("data-stores-url");
    var dataVar = root.getAttribute("data-stores-var") || "STORE_LOCATOR_DATA";
    if (!storesUrl && !window[dataVar]) {
      console.error("[store-locator] Either data-stores-url or window." + dataVar + " is required.");
      return;
    }

    var isMapbox = !forceFree && !!(window.mapboxgl && maplibregl === window.mapboxgl);
    var boldFont = isMapbox ? ["DIN Pro Bold", "Arial Unicode MS Bold"] : ["Noto Sans Bold"];

    var styleUrl = forceFree ? DEFAULT_STYLE : (root.getAttribute("data-style") || (isMapbox ? MAPBOX_STYLE : DEFAULT_STYLE));
    var center = (root.getAttribute("data-center") || "-98,39").split(",").map(Number);
    var zoom = Number(root.getAttribute("data-zoom") || 3.6);
    var clusterMaxZoom = Number(root.getAttribute("data-cluster-max-zoom") || 14);
    var defaultBrand = root.getAttribute("data-default-brand") || "CVS";

    var markerIcon = root.getAttribute("data-marker-icon") || "";
    var markerSize = Number(root.getAttribute("data-marker-size") || 44);
    var pinIcon = root.getAttribute("data-pin-icon") || "";
    var clusterColor = root.getAttribute("data-cluster-color") || "";
    var dirColor = root.getAttribute("data-directions-color") || "";
    var mapboxToken = root.getAttribute("data-mapbox-token") || "";
    var pinHtml = pinIcon
      ? '<img class="sl-card-pin-img" src="' + escapeHtml(pinIcon) + '" alt="">'
      : SVG_PIN;

    root.innerHTML = "";
    var tabsEl = el("div", "sl-tabs");
    var bodyEl = el("div", "sl-body");
    var listColEl = el("div", "sl-list-col");
    var searchEl = el("div", "sl-search");
    searchEl.innerHTML =
      '<div class="sl-search-wrap">' +
        '<input class="sl-search-input" type="text" autocomplete="off" placeholder="Search a store, ZIP, or city" aria-label="Search stores">' +
        '<button class="sl-search-btn" type="button" aria-label="Search">🔍</button>' +
      "</div>" +
      '<div class="sl-search-msg" role="status"></div>';
    var listEl = el("div", "sl-list");
    var mapEl = el("div", "sl-map");
    listEl.appendChild(el("div", "sl-list-empty", "Loading stores…"));
    listColEl.appendChild(searchEl);
    listColEl.appendChild(listEl);
    bodyEl.appendChild(listColEl);
    bodyEl.appendChild(mapEl);
    root.appendChild(tabsEl);
    root.appendChild(bodyEl);

    var searchInput = searchEl.querySelector(".sl-search-input");
    var searchMsg = searchEl.querySelector(".sl-search-msg");
    var searchDebounce = null;
    searchInput.addEventListener("input", function () {
      searchText = searchInput.value.trim();
      if (searchDebounce) clearTimeout(searchDebounce);
      searchDebounce = setTimeout(function () {
        if (searchText) renderDisplayed();
        else applyList(computeInBounds());
      }, 180);
    });
    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); doSearch(searchInput.value.trim()); }
    });
    searchEl.querySelector(".sl-search-btn").addEventListener("click", function () {
      doSearch(searchInput.value.trim());
    });

    var map = new maplibregl.Map({
      container: mapEl,
      style: styleUrl,
      center: [center[0] || -98, center[1] || 39],
      zoom: zoom,
    });
    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), "bottom-right");
    root._slMap = map;

    if (isMapbox) {
      var fellBack = false;
      map.on("error", function (e) {
        if (fellBack) return;
        var err = e && e.error;
        var st = err && (err.status || (err.response && err.response.status));
        if (st === 401 || st === 403 || st === 429) {
          fellBack = true;
          console.warn("[store-locator] Mapbox 오류(" + st + ") -> OpenFreeMap 으로 전환");
          try { map.remove(); } catch (x) {}
          ensureMapLibre().then(function (ml) { initWidget(ml, root, true); });
        }
      });
    }

    var popupOffset = markerIcon ? markerSize + 12 : 22;

    var popup = new maplibregl.Popup({ closeButton: true, closeOnClick: false, focusAfterOpen: false, offset: popupOffset, maxWidth: "280px", anchor: "bottom" });

    var allFeatures = [];
    var viewFeatures = [];
    var boundsFeatures = [];
    var listFeatures = [];
    var searchText = "";
    var cardById = {};
    var activeBrand = null;
    var RENDER_STEP = 80;
    var rendered = 0;
    var loadingEl = el("div", "sl-loading", '<span class="sl-spinner"></span>');
    var loadingShown = false;
    var moveTimer = null;
    var activeId = null;
    var pendingScrollId = null;
    var pendingTimer = null;
    var markerModeOn = null;
    var lastKey = "";
    var pendingArr = null;
    var pendingKey = "";

    listEl.addEventListener("scroll", function () {
      if (rendered >= listFeatures.length) return;
      if (listEl.scrollTop + listEl.clientHeight >= listEl.scrollHeight - 240) appendCards(RENDER_STEP);
    });

    function brandOf(f) { return f.properties.brand || defaultBrand; }
    function fcOf(features) { return { type: "FeatureCollection", features: features }; }

    (storesUrl
      ? fetch(storesUrl).then(function (r) { return r.json(); })
      : Promise.resolve(window[dataVar])
    ).then(function (geojson) {
      allFeatures = (geojson.features || []).filter(function (f) {
        return f.geometry && f.geometry.coordinates;
      });

      var brands = [];
      allFeatures.forEach(function (f) {
        var b = brandOf(f);
        if (brands.indexOf(b) === -1) brands.push(b);
      });
      if (!brands.length) brands = [defaultBrand];
      activeBrand = brands[0];
      renderTabs(brands);

      function setup() {
        addLayers();
        selectBrand(activeBrand);
        locateUser();
      }
      if (map.loaded()) setup();
      else map.on("load", setup);
    }).catch(function (err) {
      listEl.innerHTML = "";
      listEl.appendChild(el("div", "sl-list-empty", "Failed to load store data."));
      console.error("[store-locator] Failed to load data:", err);
    });

    function renderTabs(brands) {
      tabsEl.innerHTML = "";
      brands.forEach(function (b) {
        var t = el("button", "sl-tab" + (b === activeBrand ? " active" : ""), escapeHtml(b));
        t.addEventListener("click", function () {
          if (b === activeBrand) return;
          activeBrand = b;
          tabsEl.querySelectorAll(".sl-tab").forEach(function (n) { n.classList.remove("active"); });
          t.classList.add("active");
          selectBrand(b);
        });
        tabsEl.appendChild(t);
      });
    }

    function addLayers() {
      map.addSource("stores", {
        type: "geojson",
        data: fcOf([]),
        cluster: true,
        clusterMaxZoom: clusterMaxZoom,
        clusterRadius: 60,
      });
      map.addLayer({
        id: "clusters", type: "circle", source: "stores", filter: ["has", "point_count"],
        paint: {
          "circle-color": clusterColor || ["step", ["get", "point_count"], "#f08c8c", 50, "#e35656", 200, BRAND_COLOR],
          "circle-radius": ["step", ["get", "point_count"], 20, 50, 26, 200, 34],
          "circle-stroke-width": 3,
          "circle-stroke-color": "rgba(204,0,0,0.5)",
        },
      });
      map.addLayer({
        id: "cluster-count", type: "symbol", source: "stores", filter: ["has", "point_count"],
        layout: { "text-field": "{point_count_abbreviated}", "text-font": boldFont, "text-size": 15 },
        paint: { "text-color": "#ffffff" },
      });

      map.addLayer({
        id: "unclustered-count-circle", type: "circle", source: "stores",
        filter: ["!", ["has", "point_count"]],
        paint: {
          "circle-color": clusterColor || "#f08c8c",
          "circle-radius": 18,
          "circle-stroke-width": 3,
          "circle-stroke-color": "rgba(204,0,0,0.5)",
        },
      });
      map.addLayer({
        id: "unclustered-count", type: "symbol", source: "stores",
        filter: ["!", ["has", "point_count"]],
        layout: {
          "text-field": "1", "text-font": boldFont, "text-size": 14,
          "text-allow-overlap": true, "text-ignore-placement": true,
        },
        paint: { "text-color": "#ffffff" },
      });

      if (markerIcon) {
        loadMapImage(map, markerIcon).then(function (image) {
          if (!image) { addCircleMarker(); }
          else {
            if (!map.hasImage("sl-marker")) map.addImage("sl-marker", image);
            map.addLayer({
              id: "unclustered-point", type: "symbol", source: "stores",
              filter: ["!", ["has", "point_count"]],
              layout: {
                "icon-image": "sl-marker",
                "icon-size": markerSize / (image.height || markerSize),
                "icon-allow-overlap": true,
                "icon-anchor": "bottom",
              },
              paint: { "icon-opacity": 0 },
            });
          }
          attachPointHandlers();
          updateMarkerMode();
        }).catch(function () { addCircleMarker(); attachPointHandlers(); updateMarkerMode(); });
      } else {
        addCircleMarker();
        attachPointHandlers();
        updateMarkerMode();
      }

      function addCircleMarker() {
        map.addLayer({
          id: "unclustered-point", type: "circle", source: "stores",
          filter: ["!", ["has", "point_count"]],
          paint: {
            "circle-color": BRAND_COLOR,
            "circle-radius": 8,
            "circle-stroke-width": 2.5,
            "circle-stroke-color": "#ffffff",
            "circle-opacity": 0,
            "circle-stroke-opacity": 0,
          },
        });
      }
      function attachPointHandlers() {
        map.on("click", "unclustered-point", function (e) {
          if (!markerModeOn) return;
          var f = e.features[0];
          flyToStore(f);
          setActive(f.properties.id);
        });
        map.on("click", "unclustered-count-circle", function (e) {
          if (markerModeOn) return;
          var f = e.features[0];
          expandStore(f);
          setActive(f.properties.id, true);
        });
        ["unclustered-point", "unclustered-count-circle"].forEach(function (layer) {
          map.on("mouseenter", layer, function () { map.getCanvas().style.cursor = "pointer"; });
          map.on("mouseleave", layer, function () { map.getCanvas().style.cursor = ""; });
        });
      }

      map.on("click", "clusters", function (e) {
        var f = map.queryRenderedFeatures(e.point, { layers: ["clusters"] })[0];
        if (!f) return;
        var done = function (z) { if (z != null) map.easeTo({ center: f.geometry.coordinates, zoom: z }); };
        // MapLibre v4: Promise 반환 / Mapbox GL: 콜백 — 둘 다 지원
        var ret = map.getSource("stores").getClusterExpansionZoom(f.properties.cluster_id, function (err, z) {
          if (!err) done(z);
        });
        if (ret && typeof ret.then === "function") ret.then(done, function () {});
      });
      map.on("mouseenter", "clusters", function () { map.getCanvas().style.cursor = "pointer"; });
      map.on("mouseleave", "clusters", function () { map.getCanvas().style.cursor = ""; });

      map.on("click", function (e) {
        var layers = ["unclustered-point", "unclustered-count-circle", "clusters"].filter(function (l) { return map.getLayer(l); });
        var hits = layers.length ? map.queryRenderedFeatures(e.point, { layers: layers }) : [];
        if (!hits.length) popup.remove();
      });

      map.on("zoomend", function () {
        if (popup.isOpen() && map.getZoom() <= clusterMaxZoom) popup.remove();
      });

      map.on("moveend", scheduleListUpdate);
      map.on("idle", updateMarkerMode);
    }

    function fadeLayer(id, on) {
      if (!map.getLayer(id)) return;
      var o = on ? 1 : 0;
      if (map.getLayer(id).type === "circle") {
        map.setPaintProperty(id, "circle-opacity", o);
        map.setPaintProperty(id, "circle-stroke-opacity", o);
      } else {
        map.setPaintProperty(id, "icon-opacity", o);
        map.setPaintProperty(id, "text-opacity", o);
      }
    }

    function updateMarkerMode() {
      if (!map.getLayer("clusters")) return;
      var hasClusters = map.queryRenderedFeatures({ layers: ["clusters"] }).length > 0;
      var on = !hasClusters;
      if (on === markerModeOn) return;
      markerModeOn = on;
      fadeLayer("unclustered-point", on);
      fadeLayer("unclustered-count-circle", !on);
      fadeLayer("unclustered-count", !on);
    }

    function selectBrand(brand) {
      viewFeatures = allFeatures.filter(function (f) { return brandOf(f) === brand; });
      if (map.getSource("stores")) map.getSource("stores").setData(fcOf(viewFeatures));
      applyList(computeInBounds());
    }

    function computeInBounds() {
      var b = map.getBounds(), c = map.getCenter();
      var arr = viewFeatures.filter(function (f) {
        var co = f.geometry.coordinates;
        f._dist = distanceKm(c.lng, c.lat, co[0], co[1]);
        return b.contains(co);
      });
      arr.sort(function (a, b) { return a._dist - b._dist; });
      return arr;
    }

    function viewKey(arr) {
      var ids = [];
      for (var i = 0; i < arr.length; i++) ids.push(arr[i].properties.id);
      ids.sort();
      return ids.join(",");
    }

    function applyList(arr) {
      lastKey = viewKey(arr);
      boundsFeatures = arr;
      renderDisplayed();
    }

    function renderDisplayed() {
      if (searchText) {
        var q = searchText.toLowerCase();
        var c = map.getCenter();
        listFeatures = viewFeatures.filter(function (f) {
          var p = f.properties;
          return ((p.name || "") + " " + (p.address || "")).toLowerCase().indexOf(q) !== -1;
        });
        listFeatures.forEach(function (f) {
          var co = f.geometry.coordinates;
          f._dist = distanceKm(c.lng, c.lat, co[0], co[1]);
        });
        listFeatures.sort(function (a, b) { return a._dist - b._dist; });
      } else {
        listFeatures = boundsFeatures;
      }
      renderList();
    }

    function scheduleListUpdate() {
      if (searchText) return;
      var arr = computeInBounds();
      var key = viewKey(arr);
      if (key === lastKey) return;
      pendingArr = arr;
      pendingKey = key;
      showListLoading();
      if (moveTimer) clearTimeout(moveTimer);
      moveTimer = setTimeout(function () {
        moveTimer = null;
        lastKey = pendingKey;
        boundsFeatures = pendingArr;
        renderDisplayed();
      }, 250);
    }

    function showListLoading() {
      if (loadingShown) return;
      loadingShown = true;
      listEl.innerHTML = "";
      cardById = {};
      rendered = 0;
      listEl.appendChild(loadingEl);
    }

    function buildCard(f) {
      var p = f.properties;
      var card = el("div", "sl-card");
      card.setAttribute("data-id", p.id);
      var dist = (f._dist != null) ? '<span class="sl-card-dist">' + fmtDistance(f._dist) + "</span>" : "";
      card.innerHTML =
        '<div class="sl-card-icon">' + pinHtml + "</div>" +
        '<div class="sl-card-body">' +
          dist +
          '<div class="sl-card-title">' + escapeHtml(brandOf(f)) + "</div>" +
          '<div class="sl-card-addr">' + escapeHtml(p.name || "") +
            (p.address ? "<br>" + escapeHtml(p.address) : "") + "</div>" +
          '<div class="sl-card-brand">' + escapeHtml(brandOf(f)) + "</div>" +
        "</div>";
      card.addEventListener("click", function () {
        focusStore(f);
        setActive(p.id);
      });
      cardById[p.id] = card;
      return card;
    }

    function appendCards(count) {
      var end = Math.min(rendered + count, listFeatures.length);
      var frag = document.createDocumentFragment();
      for (var i = rendered; i < end; i++) frag.appendChild(buildCard(listFeatures[i]));
      listEl.appendChild(frag);
      rendered = end;
    }

    function renderList() {
      listEl.innerHTML = "";
      cardById = {};
      rendered = 0;
      loadingShown = false;
      if (!listFeatures.length) {
        var emptyMsg = searchText
          ? "No matches for “" + escapeHtml(searchText) + "”."
          : "No stores in the current map view.";
        listEl.appendChild(el("div", "sl-list-empty", emptyMsg));
        return;
      }
      appendCards(RENDER_STEP);

      if (activeId != null) {
        ensureRendered(activeId);
        if (cardById[activeId]) cardById[activeId].classList.add("active");
      }
      if (pendingScrollId != null) {
        ensureRendered(pendingScrollId);
        scrollCardToTop(pendingScrollId);
        pendingScrollId = null;
        if (pendingTimer) { clearTimeout(pendingTimer); pendingTimer = null; }
      }
    }

    function ensureRendered(id) {
      if (cardById[id]) return;
      for (var i = rendered; i < listFeatures.length; i++) {
        if (String(listFeatures[i].properties.id) === String(id)) {
          appendCards(i - rendered + 1);
          return;
        }
      }
    }

    function highlightCard(id) {
      listEl.querySelectorAll(".sl-card.active").forEach(function (n) { n.classList.remove("active"); });
      var card = cardById[id];
      if (card) card.classList.add("active");
    }

    function scrollCardToTop(id) {
      var card = cardById[id];
      if (!card) return;
      listEl.scrollTo({ top: card.offsetTop - listEl.offsetTop, behavior: "smooth" });
    }

    function setActive(id, deferOnly) {
      activeId = id;
      if (!deferOnly) {
        ensureRendered(id);
        highlightCard(id);
        scrollCardToTop(id);
      }
      pendingScrollId = id;
      if (pendingTimer) clearTimeout(pendingTimer);
      pendingTimer = setTimeout(function () { pendingScrollId = null; pendingTimer = null; }, 1500);
    }

    function openStorePopup(feature) {
      var p = feature.properties;
      var c = feature.geometry.coordinates;

      var destText = [p.name, p.address].filter(Boolean).join(", ");
      var dest = destText ? encodeURIComponent(destText) : c[1] + "," + c[0];
      var dir = "https://www.google.com/maps/dir/?api=1&destination=" + dest;
      var brand = p.brand || defaultBrand;
      var html =
        '<div class="sl-popup-title">' + escapeHtml(brand) + "</div>" +
        '<div class="sl-popup-addr">' +
          escapeHtml(p.name || "") + (p.address ? "<br>" + escapeHtml(p.address) : "") +
          '<div class="sl-popup-brand">' + escapeHtml(brand) + "</div>" +
        "</div>" +
        (p.approx ? '<div class="sl-popup-approx">※ Approximate location (based on ZIP code)</div>' : "") +
        '<a class="sl-popup-dir"' + (dirColor ? ' style="background:' + escapeHtml(dirColor) + '"' : "") +
          ' href="' + dir + '" target="_blank" rel="noopener">Directions</a>';
      popup.setLngLat(c).setHTML(html).addTo(map);
    }

    function flyToStore(f) {

      openStorePopup(f);
      ensurePopupInView();
    }

    function expandStore(f) {
      openStorePopup(f);
      map.flyTo({ center: f.geometry.coordinates, zoom: Math.max(map.getZoom(), clusterMaxZoom + 1), duration: 800 });
    }

    function ensurePopupInView() {
      var elPopup = popup.getElement();
      if (!elPopup) return;
      requestAnimationFrame(function () {
        var pr = elPopup.getBoundingClientRect();
        var mr = mapEl.getBoundingClientRect();
        var pad = 12;
        var dx = 0, dy = 0;
        if (pr.left < mr.left + pad) dx = -((mr.left + pad) - pr.left);
        else if (pr.right > mr.right - pad) dx = pr.right - (mr.right - pad);
        if (pr.top < mr.top + pad) dy = -((mr.top + pad) - pr.top);
        else if (pr.bottom > mr.bottom - pad) dy = pr.bottom - (mr.bottom - pad);
        if (dx || dy) map.panBy([dx, dy], { duration: 250 });
      });
    }

    function focusStore(f) {

      var targetZoom = Math.max(map.getZoom(), clusterMaxZoom + 1);
      openStorePopup(f);
      map.jumpTo({ center: f.geometry.coordinates, zoom: targetZoom });
      ensurePopupInView();
    }

    function locateUser() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var userLoc = [pos.coords.longitude, pos.coords.latitude];
          if (viewFeatures.length) map.flyTo({ center: userLoc, zoom: 9, speed: 1.2 });
        },
        function () {  },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
      );
    }

    function flashSearch(msg) {
      searchMsg.textContent = msg || "";
      if (msg) setTimeout(function () { if (searchMsg.textContent === msg) searchMsg.textContent = ""; }, 2500);
    }

    function doSearch(q) {
      if (!q) return;
      searchText = q;
      searchInput.value = q;
      renderDisplayed();
      if (listFeatures.length) {
        flashSearch("");
        fitToFeatures(listFeatures);
      } else {
        doGeocode(q);
      }
    }

    function fitToFeatures(feats) {
      if (!feats.length) return;
      if (feats.length === 1) {
        map.flyTo({ center: feats[0].geometry.coordinates, zoom: 12, duration: 800 });
        return;
      }
      var b = new maplibregl.LngLatBounds();
      feats.forEach(function (f) { b.extend(f.geometry.coordinates); });
      map.fitBounds(b, { padding: 60, maxZoom: 13, duration: 800 });
    }

    function doGeocode(q) {
      if (!q) return;
      flashSearch("Searching…");
      geocode(q).then(function (lngLat) {
        if (!lngLat) { flashSearch("No location found."); return; }
        flashSearch("");
        searchText = "";
        searchInput.value = "";
        map.flyTo({ center: lngLat, zoom: 11, duration: 900 });
      }).catch(function () { flashSearch("Search failed. Try again."); });
    }

    function geocode(q) {
      if (mapboxToken) {
        return mbGeocode(q).then(function (r) { return r || osmGeocode(q); }, function () { return osmGeocode(q); });
      }
      return osmGeocode(q);
    }
    function mbGeocode(q) {
      var url = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(q) +
        ".json?limit=1&country=us&access_token=" + encodeURIComponent(mapboxToken);
      return fetch(url).then(function (r) { return r.json(); }).then(function (j) {
        return j && j.features && j.features[0] ? j.features[0].center : null;
      });
    }
    function osmGeocode(q) {
      var url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us&q=" + encodeURIComponent(q);
      return fetch(url, { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); }).then(function (j) {
        return j && j[0] ? [parseFloat(j[0].lon), parseFloat(j[0].lat)] : null;
      });
    }
  }

  function startWidget(root) {
    var token = root.getAttribute("data-mapbox-token") || "";
    var ensure = token ? ensureMapbox : ensureMapLibre;
    ensure().then(function (gl) {
      if (token && gl) gl.accessToken = token;
      initWidget(gl, root);
    }).catch(function (e) { console.error("[store-locator] Failed to load map library", e); });
  }

  function boot() {
    var roots = document.querySelectorAll(".store-locator:not([data-sl-ready])");
    roots.forEach(function (root) {
      if (root.getAttribute("data-sl-ready")) return;
      root.setAttribute("data-sl-ready", "1");
      startWidget(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  window.StoreLocator = { boot: boot };
})();
